/**
 * Check if DOM is accessible (SSR)
 *
 * @returns {boolean} is DOM available
 */
export default function canUseDOM() {
  return !!(
    typeof window !== 'undefined' &&
            window.document &&
            window.document.createElement
  );
}
